<script setup lang="ts">
import { roles } from '~/enums'
import { useCurrentRoleStore } from '~/stores/currentRole'

const { playSelectSound } = useSound()
const { currentRole } = storeToRefs(useCurrentRoleStore())
const user = useSupabaseUser()

const homeActions = computed(() => {
  if (currentRole.value.role === roles.SYSTEM_ADMIN) {
    return [{ label: 'My dashboard', path: '/dashboard/system-admin' }]
  }
  if (currentRole.value.role === roles.ADMIN) {
    return [{ label: 'My dashboard', path: '/dashboard/admin' }]
  }
  if (currentRole.value.role === roles.TEACHER) {
    return [
      { label: 'My dashboard', path: '/dashboard/teacher' },
      { label: 'My classes', path: '/classes' },
    ]
  }
  return [
    { label: 'Start my classes', path: '/classes' },
    { label: 'Start my adventure', path: '/adventure' },
  ]
})

function start(path: string) {
  playSelectSound()
  navigateTo(path)
}

onMounted(() => {
  if (currentRole.value.role === roles.GUARDIAN) {
    navigateTo('/dashboard/parent')
  }
})
</script>

<template>
  <div
    class="relative min-h-[100dvh] overflow-hidden bg-[#dff6ff] bg-cover bg-center bg-no-repeat"
    style="background-image: url('/img/homepage-background.webp')"
  >
    <img
      v-if="!user"
      class="pointer-events-none absolute ml-4 md:ml-0 left-1/5 md:left-1/2 top-[calc(env(safe-area-inset-top)+1.85rem)] z-20 w-[min(11rem,42vw)] -translate-x-1/2 object-contain md:w-[min(16rem,22vw)]"
      src="/img/mascot/logo-blue.webp"
      alt="WLearn — Learning for the future"
    />
    <section
      class="mx-auto flex min-h-[100dvh] max-w-6xl flex-col items-center justify-center gap-8 px-6 pb-16 pt-[calc(env(safe-area-inset-top)+5rem)] md:flex-row md:gap-12"
    >
      <img
        class="hidden w-[min(34rem,50vw)] max-h-[min(56vh,28rem)] object-contain md:block"
        src="/img/mascot/mascot-pointing.webp"
        alt="WLearn mascot pointing to the start options"
      />
      <img
        class="w-[min(30rem,80vw)] max-h-[min(56vh,28rem)] object-contain md:hidden"
        src="/img/mascot/mascot-splash.webp"
        alt="WLearn mascot"
      />
      <div class="flex w-full max-w-sm flex-col gap-12 md:w-[min(23rem,34vw)]">
        <AppActionButton
          v-for="action in homeActions"
          :key="action.path"
          class="w-full py-5 text-[clamp(1.25rem,2.4vw,1.6rem)]"
          size="xl"
          @click="start(action.path)"
        >
          {{ action.label }}
        </AppActionButton>
      </div>
    </section>
  </div>
</template>
